(function() {
    window.c24.lp.ac.ks = {

        ac: null,
        searchInput: null,
        listItems: null,
        insurerList: [],

        init: function(ac) {

            this.ac = ac;

            this.searchInput = $('input.search', this.ac),
            this.deleteInput = $('.delete-icon', this.ac),
            this.listItems = $('.dropdown-list span', this.ac);

            this.insurerList = this.loadInsurerList();

            const ks = this;
            const areaID = window.c24LpAreaId ? window.c24LpAreaId : '';

            this.searchInput.on('focus click', function () {

                $('.widgetWrapper', this.ac).addClass('fixed');
                window.scrollTo(0, 0);
                $('body').css({
                    overflow: 'hidden',
                });

                ks.showDropdown();
            });

            this.searchInput.on('focusout', function () {

                $('.widgetWrapper', this.ac).removeClass('fixed');
                $('body').css({
                    overflow: 'visible',
                });

                ks.hideDropdown();
            });

            this.searchInput.on('keyup change', function () {

                ks.clearErrors();

                const value = $(this).val().replace(/^\s+/, '');

                $(this).val(value);

                if (!value) {

                    ks.setErrorEmpty();

                    ks.hideDropdown();

                    ks.deleteInput.hide();

                    return;
                } else {
                    ks.deleteInput.css('display','inline-block');
                }

                ks.showDropdown();
            });

            this.deleteInput.on('click', function() {

                ks.searchInput.val('');

                ks.deleteInput.hide();

            });

            this.listItems.on('click mousedown', function () {

                ks.searchInput.val($(this).text());

                ks.hideDropdown();

                ks.deleteInput.css('display','inline-block');
            });

            $('form', this.ac).on('submit', function (e) {

                e.preventDefault();

                const value = ks.searchInput.val();

                if (!value) {

                    ks.setErrorEmpty();
                    $('.is-loading', this).removeClass('is-loading');
                    return;
                }

                const insurerKey = ks.getInsurerKeyFromName(value);

                if (!insurerKey) {

                    ks.setErrorUnknown();
                    $('.is-loading', this).removeClass('is-loading');
                    return;
                }

                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'cta',
                    'Cancellation_lp_cta_cancellation_clicked',
                ]);

                ks.searchInput.attr('autocomplete','on');

                const url = $(this).attr('action')
                    .replace(/([?&]insuranceKey={insuranceKey}$|insuranceKey={insuranceKey}&|[?&]insuranceKey={insuranceKey}(?=#))/, '')
                    .replace(/{insuranceKey}/i, insurerKey);

                if (url.indexOf('?') !== -1) {
                    document.location.href = url + '&source=' + areaID + '&insuranceKey=' + insurerKey;
                } else {
                    document.location.href = url + '?source=' + areaID + '&insuranceKey=' + insurerKey;
                }
            });

            $('.secondaryWrapper a', this.ac).on('click', function (e) {

                e.preventDefault();

                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'cta',
                    'Cancellation_lp_cta_switch_clicked',
                ]);

                const url = $(this).attr('href');
                if ( url.indexOf('?') !== -1 ) {
                    document.location.href = url + '&source=' + areaID + '&wpset=vc_ksv';
                } else {
                    document.location.href = url + '?source=' + areaID + '&wpset=vc_ksv';
                }
            });
        },

        loadInsurerList: function () {

            const insurerList = [];

            $.each(this.listItems, function (index, item) {

                insurerList.push({
                    key: $(item).data('key'),
                    name: $(item).text(),
                    aliases: $(item).data('aliases'),
                    nameLowerCase: $(item).text().toLowerCase(),
                });
            });

            return insurerList;
        },

        getInsurerKeyFromName: function(name) {

            const nameLowerCase = name.toLowerCase();
            let key = null;

            $.each(this.insurerList, function(index, insurer) {

                if (insurer.nameLowerCase === nameLowerCase) {
                    key = insurer.key;
                    return false;
                }

                if (insurer.key === nameLowerCase) {
                    key = insurer.key;
                    return false;
                }

                if (insurer.aliases) {
                    $.each(insurer.aliases, function (aliasIndex, alias) {
                        if (alias.toLowerCase() === nameLowerCase) {
                            key = insurer.key;
                            return false;
                        }
                    });

                    if (key) {
                        return false;
                    }
                }
            });

            return key;
        },

        setErrorEmpty: function() {

            this.clearErrors();
            $('.error-match.empty', this.ac).show();
        },

        setErrorUnknown: function() {

            this.clearErrors();
            $('.error-match.unknown', this.ac).show();
        },

        clearErrors: function() {

            $('.error-match', this.ac).hide();
        },

        showDropdown: function () {

            const value = this.searchInput.val();
            const visibleItemCount = this.filterDropdown(value);

            if (visibleItemCount < 1) {

                this.setErrorUnknown();
                this.hideDropdown();
                return;
            }

            this.searchInput.attr('autocomplete','off');
            $('.dropdown-content', this.ac).show();
        },

        hideDropdown: function () {

            $('.dropdown-content', this.ac).hide();
        },

        filterDropdown: function(value) {

            $('.dropdown-list span', this.ac).show();

            let visibleItemCount = this.insurerList.length;

            if (!value) {
                return visibleItemCount;
            }

            const ks = this;
            const valueLowerCase = value.toLowerCase();

            $.each(this.insurerList, function (index, insurer) {

                const item = $('span[data-key="' + insurer.key + '"]', ks.ac);
                let aliasMatch = false;

                if (insurer.aliases) {
                    $.each(insurer.aliases, function (index, alias) {
                        if (valueLowerCase === alias.substring(0, valueLowerCase.length)) {
                            aliasMatch = true;
                            return false;
                        }
                    });
                }

                if (valueLowerCase.length < 4 ) {

                    const itemPart = insurer.nameLowerCase.substring(0, valueLowerCase.length);

                    if (itemPart !== valueLowerCase && !aliasMatch) {
                        item.hide();
                        visibleItemCount--;
                    }

                } else {

                    if (insurer.nameLowerCase.indexOf(valueLowerCase) === -1 && !aliasMatch) {
                        item.hide();
                        visibleItemCount--;
                    }
                }

            });

            return visibleItemCount;
        },
    };

    $(document).ready(function() {

        $.each($('.mod24ac.ks'), function (index, ac) {

            const ks = Object.create(window.c24.lp.ac.ks);
            ks.init(ac);
        });
    });
})();
